export default function CTAConversion() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Colorful%20flat%20lay%20of%20fashion%20accessories%20including%20designer%20sunglasses%20leather%20belts%20silk%20scarves%20and%20minimalist%20jewelry%20pieces%20arranged%20on%20a%20warm%20terracotta%20colored%20surface%2C%20bright%20natural%20window%20light%20from%20upper%20left%20creating%20soft%20shadows%2C%20bohemian%20luxe%20aesthetic%20with%20mixed%20textures%20of%20metal%20fabric%20and%20leather%2C%20editorial%20product%20photography%20with%20rich%20warm%20earth%20tones%20and%20carefully%20styled%20composition%2C%20sophisticated%20yet%20approachable%20fashion%20accessory%20collection%20display&width=1400&height=500&seq=cta-v2-accessories-flatlay&orientation=landscape"
            alt="Superbuy Spreadsheet workspace"
            className="w-full h-[300px] md:h-[400px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent flex items-center">
            <div className="px-8 md:px-14 max-w-lg">
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-white leading-tight">
                Ready To Use <span className="italic font-normal text-white/80">Superbuy Spreadsheet</span> More Efficiently?
              </h2>
              <p className="mt-4 text-white/70 text-sm md:text-base">Access our complete resources and discover better ways to organize your shopping workflow.</p>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center mt-6 px-8 py-3.5 rounded-full bg-white text-foreground-950 text-sm font-semibold hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
              >
                Visit Main Website
                <span className="w-4 h-4 flex items-center justify-center ml-2"><i className="ri-arrow-right-up-line"></i></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}